// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const creditSummaryModule = "CreditSummaryModule__creditSummaryModule__tCTnj";
export const chartWrapper = "CreditSummaryModule__chartWrapper__3AzNc";
export const label = "CreditSummaryModule__label__v07BL";
export const linkCreditButtonWrapper = "CreditSummaryModule__linkCreditButtonWrapper__Brtqe";